import { render } from "./AboutProduct.vue?vue&type=template&id=9cb15118&scoped=true"
import script from "./AboutProduct.vue?vue&type=script&lang=js"
export * from "./AboutProduct.vue?vue&type=script&lang=js"

import "./AboutProduct.vue?vue&type=style&index=0&id=9cb15118&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cb15118"],['__file',"webpack-assets/vue/templates/product/catalog/parts/AboutProduct.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9cb15118"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9cb15118', __exports__)) {
    api.reload('9cb15118', __exports__)
  }
  
  module.hot.accept("./AboutProduct.vue?vue&type=template&id=9cb15118&scoped=true", () => {
    api.rerender('9cb15118', render)
  })

}


export default __exports__